import React from "react";

export function CoreGrowth() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" viewBox="0 0 60 60" fill="none">
      <g clipPath="url(#clip0_528_99)">
        <path d="M17.6953 10.5469H22.9688V45.8203H37.0312V10.5469H42.3047L30 0L17.6953 10.5469Z" fill="#157FE3" />
        <path d="M49.3359 31.7578H52.8516L44.0625 21.2126L40.5469 25.4308V45.8203H49.3359V31.7578Z" fill="#157FE3" />
        <path d="M19.4531 45.8203V25.4308L15.9375 21.2126L7.14844 31.7578H10.6641V45.8203H19.4531Z" fill="#157FE3" />
        <path d="M40.7539 49.3359L46.0265 60H59.9991L51.0937 49.3359H40.7539Z" fill="#157FE3" />
        <path d="M23.1755 49.3359L17.9023 60H42.095L36.8224 49.3359H23.1755Z" fill="#157FE3" />
        <path d="M19.2458 49.3359H8.90543L0 60H13.9729L19.2458 49.3359Z" fill="#157FE3" />
      </g>
      <defs>
        <clipPath id="clip0_528_99">
          <rect width="60" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
